import React, { useEffect, useLayoutEffect, useRef } from "react";
import ReactSignatureCanvas from "react-signature-canvas";
import { resizeCanvas } from "../common/interactiveCommon";
const KS2Sign = (props) => {
  const { setSignatureData, setDateData, day1, day2, month1, month2, year3, year4 } = props;
  const signatureRef = useRef(null);
  const day1Ref = useRef(null);
  const day2Ref = useRef(null);
  const month1Ref = useRef(null);
  const month2Ref = useRef(null);

  const year3Ref = useRef(null);
  const year4Ref = useRef(null);

  

  useLayoutEffect( () => {
    resizeCanvas(signatureRef);
  },[]);
  
  useEffect(() => {
    if (props.signature === "" && signatureRef.current) {
      signatureRef.current.clear();
    }
  }, [props.signature]);
  const clearSignature = () => {
    signatureRef.current.clear();
    setSignatureData("");
  };

  const onDateChange = (e) => {
    let data = e.target.value;
    if (isNaN(Number(data))) {
      return;
    }
    switch (e.target.name) {
      case "day1":
        day2Ref.current.focus();
        break;
      case "day2":
        month1Ref.current.focus();
        break;
      case "month1":
        month2Ref.current.focus();
        break;
      case "month2":
        year3Ref.current.focus();
        break;
      case "year3":
        year4Ref.current.focus();
        break;
    }
    setDateData({ name: e.target.name, value: data });
  };

  return (
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-12 section-number-box">
        <div className=" number">9.</div>
        <div className="col-md-7 section-label">
          <label className="">I declare that the information I have provided on this form is true and correct.</label>
        </div>
      </div>
      <div className="section-form-group">
        <div className="section-form-group-inline col-sm-12 col-md-12 col-lg-8 pr-3 ml-50 sign-wrapper">
          <div className="digital-signed mb-1">
            <div className="digital-signed-name">
              <ReactSignatureCanvas
                penColor="black"
                backgroundColor="white"
                canvasProps={{ height: 80, width: 400 }}
                ref={signatureRef}
                onEnd={() => {
                  const imageData = signatureRef.current.getTrimmedCanvas().toDataURL("image/png");
                  setSignatureData(imageData);
                }}
              />
            </div>
            <div className="sign-date">
              <input maxLength="1" placeholder="D" type="text" id="day1" name="day1" className="form-control text-center " ref={day1Ref} value={day1} onChange={onDateChange} />
              <input maxLength="1" placeholder="D" type="text" id="day2" name="day2" className="form-control text-center mr-1 " ref={day2Ref} value={day2} onChange={onDateChange} />
              <span className="font-20">/</span>

              <input maxLength="1" placeholder="M" type="text" id="month1" name="month1" className="form-control text-center" ref={month1Ref} value={month1} onChange={onDateChange} />
              <input maxLength="1" placeholder="M" type="text" id="month2" name="month2" className="form-control text-center mr-1" ref={month2Ref} value={month2} onChange={onDateChange} />
              <span className="font-20">/</span>
              <input maxLength="1" placeholder="Y" type="text" id="year3" name="year3" className="form-control text-center" ref={year3Ref} value={year3} onChange={onDateChange} required={true} />
              <input maxLength="1" placeholder="Y" type="text" id="year4" name="year4" className="form-control text-center" ref={year4Ref} value={year4} onChange={onDateChange} required={true} />
            </div>
          </div>
          <div className="small small-title-label d-flex sign-wrap">
            <span>Signature</span>
            <button type="button" onClick={clearSignature}>
              Clear signature
            </button>
            <span>Date</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KS2Sign;
